import { makeStyles, withStyles, Theme } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";

export const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    padding: "35px",
  },
  title: {
    fontSize: 24,
    fontFamily: "Termina-Heavy, Termina",
    fontWeight: 800,
    color: theme.palette.default.dark,
    lineHeight: "29px",
    letterSpacing: 1,
  },
  addnew: {
    width: 100,
    height: 32,
    borderRadius: 18,
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.palette.primary.main,
    backgroundColor: "transparent",
    fontSize: 14,
    fontFamily: "Helvetica",
    fontWeight: "normal",
    color: theme.palette.primary.main,
    letterSpacing: 1,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.system.transparentGray,
    },
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
      width: 84,
      height: 24,
      fontSize: 14,
    },
  },
  drawerWrapper: {
    width: 540,
  },
  online: {
    height: "14px",
    width: "14px",
    backgroundColor: theme.palette.primary.main,
    margin: "12px",
    borderRadius: "50%",
  },
  offline: {
    height: "14px",
    width: "14px",
    backgroundColor: theme.palette.secondary.main,
    margin: "12px",
    borderRadius: "50%",
  },
  tableRoot: {
    marginTop: 20,
  },
  buttonWrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  greyColorIcon: {
    fontSize: "22px !important",
    color: theme.palette.default.dark,
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
      fontSize: "18px !important",
    },
  },
  redColorIcon: {
    fontSize: "22px !important",
    color: theme.palette.system.crimson,
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
      fontSize: "18px !important",
    },
  },
  headerTitle: {
    fontSize: 16,
    fontFamily: "Helvetica",
    color: theme.palette.default.dark,
    lineHeight: "11px",
    paddingBottom: 10,
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
      fontSize: 14,
    },
  },
  tableContent: {
    fontSize: 16,
    fontFamily: "Helvetica",
    color: theme.palette.default.dark,
    lineHeight: "11px",
    paddingBottom: 10,
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
      fontSize: 14,
    },
  },
  buttonItem: {
    cursor: "pointer",
    marginRight: 16,
    width: 28,
    height: 28,
    borderRadius: "50%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.default.light,
    },
  },
  form: {
    background: "white",
    width: 369,
    paddingTop: 18,
    paddingLeft: 20,
    paddingRight: 20,
    paddingBottom: 26,
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  editTitle: {
    fontSize: 16,
    fontFamily: "Termina-Heavy, Termina",
    fontWeight: 800,
    color: theme.palette.system.darkGray,
    lineHeight: "20px",
    letterSpacing: 1,
    marginBottom: 24,
  },
  inputRoot: {
    width: "100%",
    marginBottom: 16,
  },
  input: {
    paddingLeft: 18,
    borderWidth: 2,
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.27)",
    borderRadius: 3,
    fontFamily: "Helvetica",
  },
  margin: {
    marginLeft: 0,
  },
  select: {
    width: "100%",
    marginBottom: 16,
  },
  storeWrapper: {
    display: "flex",
    flexDirection: "row",
  },
  storeText: {
    marginTop: theme.spacing(1),
    fontSize: 14,
    fontFamily: "Helvetica",
    color: theme.palette.system.darkGray,
    lineHeight: "11px",
    marginRight: 10,
  },
  storeItemWrapper: {
    paddingLeft: theme.spacing(1),
  },
  storeItemText: {
    fontSize: 14,
    fontFamily: "Helvetica",
    color: theme.palette.default.dark,
    lineHeight: "11px",
  },
  formControlLabelRoot: {
    marginLeft: 10,
    width: 104,
    marginBottom: 10,
  },
  storeItemInput: {
    width: 8,
    height: 8,
  },
  operateButtonWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  cancelButton: {
    width: 82,
    height: 22,
    borderRadius: 3,
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.palette.default.dark,
    backgroundColor: "transparent",
    fontSize: 14,
    fontFamily: "Helvetica",
    fontWeight: "normal",
    color: theme.palette.default.dark,
    letterSpacing: 1,
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      backgroundColor: theme.palette.system.transparentGray,
    },
  },
  saveButton: {
    marginLeft: 24,
    width: 84,
    height: 24,
    borderRadius: 3,
    borderWidth: 2,
    borderStyle: "solid",
    borderColor: theme.palette.primary.main,
    backgroundColor: "transparent",
    fontSize: 14,
    fontFamily: "Helvetica",
    fontWeight: "normal",
    color: theme.palette.primary.main,
    letterSpacing: 1,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.system.transparentGray,
    },
  },
  deleteOverlay: {
    display: "none",
    position: "fixed",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 999,
    background: "rgba(221, 221, 221, 0.5)",
    visibility: "hidden",
  },
  deleteVisible: {
    display: "block",
    visibility: "visible",
  },
  deleteModalContainer: {
    marginTop: 240,
    marginLeft: "auto",
    marginRight: "auto",
    width: 369,
    paddingTop: 22,
    paddingLeft: 42,
    paddingRight: 42,
    paddingBottom: 22,
    boxSizing: "border-box",
    backgroundColor: theme.palette.primary.contrastText,
    borderRadius: 4,
    boxShadow: "10px 10px 20px 0px rgba(0, 0, 0, 0.05)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  deleteTitle: {
    fontSize: 16,
    fontFamily: "Termina-Bold, Termina",
    fontWeight: "bold",
    color: theme.palette.default.dark,
    lineHeight: "20px",
    letterSpacing: 1,
    textAlign: "center",
  },
  deleteDesc: {
    marginTop: theme.spacing(1),
    width: 215,
    fontSize: 14,
    fontFamily: "Helvetica",
    color: theme.palette.default.dark,
    lineHeight: "20px",
    textAlign: "center",
    marginBottom: 36,
  },
  error: {
    color: "red",
  },
  buttonMargin: {
    margin: theme.spacing(1),
  },
  tableCellRoot: {
    border: 0,
  },
  tableRowRoot: {
    borderBottom: "1px solid rgba(224, 224, 224, 1)",
  },
}));

export const CssTextField = withStyles((theme: Theme) => ({
  root: {
    "& label.Mui-focused": {
      color: theme.palette.primary.main,
      opacity: 1,
    },
    "& .MuiFormLabel-filled": {
      color: theme.palette.system.darkGray,
      opacity: 1,
    },
    "& .MuiInputLabel-outlined": {
      fontFamily: "Helvetica",
      color: theme.palette.system.darkGray,
      fontSize: 14,
      transform: "translate(14px, 12px) scale(1)",
      paddingLeft: 3,
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "white",
      opacity: 0,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "rgba(0, 0, 0, 0.27)",
        opacity: 1,
        borderWidth: 2,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
        opacity: 1,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
        opacity: 1,
      },
      "& .MuiOutlinedInput-inputAdornedEnd": {
        fontFamily: "Helvetica",
        color: "black",
        fontSize: 14,
      },
    },
    "& .MuiAutocomplete-inputRoot": {
      paddingTop: 0,
      paddingBottom: 0,
      backgroundColor: theme.palette.primary.contrastText,
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -6px) scale(0.75)",
    },
    "& .MuiAutocomplete-inputRoot[class*='MuiOutlinedInput-root'] .MuiAutocomplete-input":
      {
        paddingTop: 12.375,
        paddingBottom: 12.375,
      },
  },
}))(TextField);

export const AddButton = withStyles((theme: Theme) => ({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 16,
    padding: "6px 12px",
    border: "1px solid",
    backgroundColor: theme.palette.primary.contrastText,
    borderColor: theme.palette.primary.main,
    width: 100,
    height: 32,
    borderRadius: 18,
    borderWidth: 2,
    fontFamily: "Helvetica",
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
      width: 90,
      height: 30,
      fontSize: 14,
    },
    "&:hover": {
      backgroundColor: theme.palette.system.transparentGray,
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: theme.palette.system.transparentGray,
    },
    "&:focus": {
      boxShadow: "none",
    },
    "& .MuiButton-label": {
      color: theme.palette.primary.main,
    },
  },
}))(Button);

export const SaveButton = withStyles((theme: Theme) => ({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 16,
    border: "2px solid",
    backgroundColor: theme.palette.primary.contrastText,
    borderColor: theme.palette.primary.main,
    marginLeft: 24,
    width: 84,
    height: 26,
    borderRadius: 3,
    fontFamily: "Helvetica",
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
      width: 84,
      height: 24,
      fontSize: 14,
    },
    "&:hover": {
      backgroundColor: theme.palette.system.transparentGray,
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: theme.palette.system.transparentGray,
    },
    "&:focus": {
      boxShadow: "none",
    },
    "& .MuiButton-label": {
      color: theme.palette.primary.main,
    },
  },
}))(Button);

export const CancelButton = withStyles((theme: Theme) => ({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 16,
    border: "2px solid",
    backgroundColor: theme.palette.primary.contrastText,
    borderColor: theme.palette.default.dark,
    width: 84,
    height: 26,
    borderRadius: 3,
    fontFamily: "Helvetica",
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
      width: 84,
      height: 24,
      fontSize: 14,
    },
    "&:hover": {
      backgroundColor: theme.palette.system.transparentGray,
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: theme.palette.system.transparentGray,
    },
    "&:focus": {
      boxShadow: "none",
    },
    "& .MuiButton-label": {
      color: theme.palette.default.dark,
    },
  },
}))(Button);

export const DeleteButton = withStyles((theme: Theme) => ({
  root: {
    boxShadow: "none",
    textTransform: "none",
    fontSize: 16,
    border: "2px solid",
    backgroundColor: theme.palette.primary.contrastText,
    borderColor: theme.palette.system.crimson,
    width: 84,
    height: 26,
    borderRadius: 3,
    fontFamily: "NeueHaasDisplay-Mediu, NeueHaasDisplay",
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
      width: 84,
      height: 24,
      fontSize: 14,
    },
    "&:hover": {
      backgroundColor: theme.palette.system.transparentGray,
      boxShadow: "none",
    },
    "&:active": {
      boxShadow: "none",
      backgroundColor: theme.palette.system.transparentGray,
    },
    "&:focus": {
      boxShadow: "none",
    },
    "& .MuiButton-label": {
      color: theme.palette.system.crimson,
    },
  },
}))(Button);
